/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Launchers/Content/App/AppAction/Error/Content"
  
}) {
let dtColorsOrange600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconWarning
{...childProps}
  viewPath={`${viewPath}/TysiaIconWarning`}
 fill={dtColorsOrange600}
 width={16}
 height={16}
 marginLeft={dtSpaceXxs}
/>
)}
</TysiaButtonIcon>
{children}
</React.Fragment>)
}